import { render, staticRenderFns } from "./CourseGoodsDetail.vue?vue&type=template&id=04595542"
import script from "./CourseGoodsDetail.vue?vue&type=script&lang=js"
export * from "./CourseGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseGoodsDetail.vue?vue&type=style&index=0&id=04595542&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports